bq.approvers = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.eventChange = false;
  this.approverData = {};
  this.initialApprovers = {};
  this.updatedApproverData = {approvers: [], watchers: []};
  this.currentTarget = false;
  this.addModal = false;
  this.modalType = false;
  this.modalMode = false;
  this.modalEditUrl = false;
  this.addModalVisible = false;
  this.people_filter = [];
  this.chainElement = false;
  this.$parentForm = null;
  this.allowLoadResultList = true;
  this.manualApproverData = {};
  this.pendingStatusUsed = false;
  this.submitBlocked = false;
  this.submitBlockedNote = '';
  this.manualNodeIds = [];
};

bq.approvers.DEFAULTS = {
  chainWrap:          'approver-wrap',
  approvalChain:      'approval-chain',
  chain:              'chain',
  watcherList:        'watcher-list',
  chainEnd:           'chain-end',
  chainStart:         'chain-start',
  group:              'chain-group',
  groupEnd:           'group-end',
  groupEndWidth:      16,
  node:               'chain-node',
  nodeFirst:          'chain-node-first',
  nodeLast:           'chain-node-last',
  groupFirst:         'group-row-first',
  groupLast:          'group-row-last',
  groupNodeFirst:     'group-node-first',
  groupNodeLast:      'group-node-last',
  modal:              'popover-html',
  modalClass:         'chain-node-modal',
  line:               'chain-line',
  groupRow:           'group-row',
  groupRowGhost:      'group-row-ghost',
  nodeContent:        'node-content',
  nodeTemplate:       'chain-node-template',
  groupTemplate:      'chain-group-template',
  overflow:           'chain-overflow',
  manualApproverForm: 'manual-approver-form',
  manualApproverCancel:'manual-approver-cancel',
  chainElements: {
      chainClass: 'chain',
      chainEnd: 'chain-end',
      chainLine: 'chain-line',
  },
  nodeTemplateElements: {
                        templateClass: 'chain-node-template',
                        contentClass: 'node-content',
                        modalClass: 'node-modal'
                      },
  groupTemplateElements: {
                        templateClass: 'chain-group-template',
                        groupFirst: 'group-row-first',
                        groupLast: 'group-row-last',
                        ghost: 'group-row-ghost',
                        groupClass: 'chain-group',
                        groupRowClass: 'group-row'
                      },
  userIcon:           'http://'+document.location.hostname+'/skin/frontend/buyerquest/default/images/avatar-no-image.png',
  groupIcon:          'http://'+document.location.hostname+'/skin/frontend/buyerquest/default/images/group-no-image.png',
  approverData:       {},
  customerID:         false,
  approverList:       false,
  isStatic:           false,
  rejected:           false,
  resizeId:           false,
  nodeReasonSelector: '.node-reason span',
  chainHasApproversClass: 'has-approvers'
};

bq.approvers.prototype = {
  init: function() {
    bq.debug.log('Approvers: init()', this.$element);
    var el = this.$element,
        self = this;
    this.approverData = this.options.approverData;
    this.submitBlocked = this.options.submitBlocked;
    this.submitBlockedNote = this.options.submitNote;
    this.initialApprovers = this.approverData;
    el.addClass(this.options.chainWrap);
    this.$parentForm = $(this.$element.parents('form')[0]);
    this.$parentForm.on('submit', function(e) {
      if(self.addModalVisible) {
        e.preventDefault();
      }
    });

    this._chainBuild();
    el.on('click', '[data-action]', {context: this}, this._catchEventChange);
    el.on('click', '.users.source-list li', {context: this}, this.options.approvalManual ? this._catchModalAddElementManual : this._catchModalAddElement);
    el.on('click', {context:this}, this._catchDocumentClick);
    el.on('change', '.'+this.options.modal+' .node-alternate-select', {context:this}, this._catchAdditionalChange);
    el.on('bq.approvers.update', {context: this}, this._chainUpdate);
    el.on('bq.approvers.clearModal', {context: this}, this._modalClose);
    el.on('bq.approvers.calibrate', {context: this}, this._catchCalibrate);
    el.on('bq.approvers.save', {context: this}, this._catchApproverSave);
    el.on('submit', '.' + this.options.manualApproverForm, {context: this}, this._catchManualFormSubmit);
    el.on('click', '.' + this.options.manualApproverCancel, {context: this}, this._catchManualCancel);
    $(window).on('resize', {context: this}, this._catchResizeEvent);
    $(window).on('hidden.bs.modal', {context: this}, this._catchHiddenBootstrapModal);
    this.calibrate();
    this._updateSubmitState()

    if (this.options.manualApproverForm) {
      this._defineDefaultApprovers();
    }
  },

  // EXTERNAL METHODS *******************************************

  calibrate: function() {
    bq.debug.log('Approvers: calibrate()');
    this._nodeCleanUp();
    this._groupSetRows();
    this._chainSetNodes();
    this._chainSetLines();
    this._toggleChainHasApproversClass();
    this._addApproverPopovers();
    this._updateManualNodeAction();
    this.throwEventUpdated();
  },

  getIsThemeNew: function() {
    if (typeof this.options.showNewDesign !== 'undefined') {
      return !!this.options.showNewDesign;
    }
    if (typeof window !== 'undefined' && typeof window.getIsThemeNew === 'function') {
      return !!window.getIsThemeNew();
    }

    var themeStyle = (typeof bq !== 'undefined' && bq.react && bq.react.settings)
      ? bq.react.settings.theme_style
      : null;

    if (themeStyle) {
      return ['theme-new', 'light-theme', 'dark-theme'].indexOf(themeStyle) !== -1;
    }

    return $('body').is('.theme-new, .light-theme, .dark-theme');
  },

  // INTERNAL METHODS *******************************************

  _approverInit: function() {
    bq.debug.log('Approvers: initApprover()');
    var $this = this,
        element = this.$element,
        chain = this.chainElement,
        line = this.options.line,
        approverData = this.approverData,
        groupTemplate = this.options.groupTemplate,
        groupClass = this.options.group,
        nodeTemplate = this.options.nodeTemplate,
        nodeTemplateElements = this.options.nodeTemplateElements,
        nodeClass = this.options.node,
        nodeModal = '.'+this.options.modal,
        groupID = 0,
        groupRowID = 0,
        custIcon = this.options.userIcon,
        groupIcon = this.options.groupIcon,
        rejected = this.options.rejected,
        groupFirst = '.'+this.options.groupFirst,
        groupLast = '.'+this.options.groupLast,
        groupTemplateElements = this.options.groupTemplateElements,
        chainElements = this.options.chainElements,
        nodeContent = this.options.nodeContent,
        watcherList = '.'+this.options.watcherList;

    var lineTplName = this.options.showNewDesign ? 'lineWithIcon' : 'line';
    if(approverData) {
      // ADD APPROVERS and create chain
      $.each(approverData, function(group) {
        if(group === 'approvers') {
          $.each(approverData[group], function(object) {
            var rowCount = approverData[group][object].length;
            if(rowCount > 0) {
              $this._templateCreate('groupBlank', groupTemplateElements).insertBefore(element.find('.chain-finish')).addClass('group-'+groupID);
              $this._templateCreate(lineTplName, chainElements).appendTo(element.find(groupFirst));
              $this._templateCreate(lineTplName, chainElements).appendTo(element.find(groupLast));
              $.each(approverData[group][object], function(row){
                $this._templateCreate('groupRowBlank', groupTemplateElements).insertBefore(element.find('.group-'+groupID +' .group-finish')).addClass('group-row-'+groupRowID);
                $this._templateCreate(lineTplName, chainElements).appendTo(element.find('.group-'+groupID +' .group-row'));
                $this._templateCreate('groupGhost', groupTemplateElements).insertBefore(element.find('.group-'+groupID +' .group-finish'));
                $.each(approverData[group][object][row], function(node) {
                  var id = approverData[group][object][row][node],
                      nodeClone = chain.find('.'+nodeTemplate).clone();
                  nodeClone.appendTo(element.find('.group-row-'+groupRowID)).removeClass(nodeTemplate).addClass(nodeClass).attr('data-node-id', id);
                  $this._templateCreate(lineTplName, chainElements).insertAfter(nodeClone);
                });
                groupRowID++;
              });
              groupID++;
            }
            $this._templateCreate(lineTplName, chainElements).insertBefore(element.find('.chain-finish'));
          });
        }
      });

      // ADD WATCHERS
      $.each(approverData, function(group) {
        if(group === 'watchers') {
          $.each(approverData[group], function(watcher) {
            var add = element.find('.watcher-action');
            $this._templateCreate('watcherBlank').appendTo(element.find(watcherList)).attr('data-watcher-id',approverData[group][watcher]);
            $(add).appendTo(element.find(watcherList));
          });
        }
      });

      // PARSE NODES (update approvers and watchers with info)
      var a = 0,
          p = 0;
      $.each(approverData, function(type) {
        if(type === 'nodes') {
          $.each(approverData[type], function(object) {
            $.each(approverData[type][object], function(node) {
              var nodeID = node,
                  data = approverData[type][object][node];

              $this._nodeLoad(nodeID, data);

              switch(data.status) {
                  case 0:
                  case 1:
                  case 2://pending
                      p++;
                      break;
                  case 3: //approved
                      a++;
                      break;
                  case 4: //rejected
                      rejected = true;
                      break;
              }
            });
          });
        }
      });
      var text = element.parent().find('.approver-text');
      if(!rejected) {
        if((a != 0) || (p != 0)) {
          text.html(a +' ' + bq.messages.approvers.approvedText + ', ' + p + ' ' + bq.messages.approvers.pendingText);
        }
        if((a != 0) && (p == 0)) {
          $('.chain-finish.chain-end').addClass('completed');
        }
      } else {
        text.html(bq.messages.approvers.approvalRejection);
        this.options.rejected = true;
      }
    }
  },

  _toggleChainHasApproversClass: function() {
    var isNewDesign = this.getIsThemeNew();
    var chain = this.$element.find('.approval-chain > .' + this.options.chain);
    if (!chain.length) {
      return;
    }
    if (!isNewDesign) {
      chain.removeClass(this.options.chainHasApproversClass);
      return;
    }

    var hasApprovers = chain.find('.' + this.options.node).length > 0;
    chain.toggleClass(this.options.chainHasApproversClass, hasApprovers);
  },

  _buildJsonSave: function(){
    bq.debug.log('Approvers: _buildJsonSave()');
    var $this = this,
        watcherList = this.$element.find('.'+this.options.watcherList),
        chain = this.$element.find('.chain');
    $this.updatedApproverData = {approvers: [], watchers: [], reasons: {}};
    var watchers = $this.updatedApproverData.watchers;
    $.each(watcherList.find('li'), function(){
      var id = $(this).data('watcherId');
      if(id) {
        watchers.push(id);
      }
    });
    var approvers = [],
        reasons = {},
        exclude = '.chain-line, .chain-end, .chain-group-template, .chain-node-template';
    $(chain).children('div').not(exclude).each(function(){
      var el = $(this);
      if(el.hasClass('chain-node')) {
        var nodeId = el.data('nodeId');
        approvers.push([[nodeId]]);
        var reason = el.find($this.options.nodeReasonSelector).text().trim();
        if (reason) {
            reasons[nodeId] = reason;
        }
      } else if(el.hasClass('chain-group')) {
        var group = [];
        el.find('.group-row').each(function(){
          var row = [],
              groupEl = $(this);
          groupEl.find('.chain-node').each(function(){
            var nodeId = $(this).data('nodeId');
            row.push(nodeId);
            var reason = $(this).find($this.options.nodeReasonSelector).text().trim();
            if (reason) {
                reasons[nodeId] = reason;
            }
          });
          group.push(row);
        });
        approvers.push(group);
      }
    });
    this.updatedApproverData.approvers = approvers;
    this.updatedApproverData.reasons = reasons;

    if (!this.updatedApproverData.ruleIds) {
      var nodes = $this.approverData.nodes;
      var ruleIds = {};

      if (Array.isArray(nodes[0])) {
        $.each(nodes[0], function(id, node) {
          if (Array.isArray(node.rule_ids)) {
            ruleIds[id] = node.rule_ids.join(',');
          }
        });
      }

      this.updatedApproverData.ruleIds = ruleIds;
    }

  },

  _chainBuild: function() {
    bq.debug.log('Approvers: _chainBuild()');
    var el = this.$element,
        chainClass = '.'+this.options.chain,
        nodeClass = '.'+this.options.node,
        nodeTemplate = '.'+this.options.nodeTemplate,
        nodeContent = '.'+this.options.nodeContent,
        group = '.'+this.options.groupTemplate,
        groupRow = '.'+this.options.groupRow,
        groupFirst = '.'+this.options.groupFirst,
        groupLast = '.'+this.options.groupLast,
        line = '.'+this.options.line;

    var beforeElement = false;
    if( el.find('.chain-additional-data-after').length ) {
      beforeElement = el.find('.chain-additional-data-after');
    }

    //check if need to put elements before special container
    var chainTextTpl = this._templateCreate('chainText');
    var chainGradientsTpl = this._templateCreate('chainGradients');
    var chainTpl = this._templateCreate('chain', this.options.chainElements);
    var lineTplName = this.options.showNewDesign ? 'lineWithIcon' : 'line';
    if (beforeElement) {
      chainTextTpl.insertBefore(beforeElement);
      chainGradientsTpl.insertBefore(beforeElement);
      chainTpl.insertBefore(beforeElement);
    } else {
      chainTextTpl.appendTo(el);
      chainGradientsTpl.appendTo(el);
      chainTpl.appendTo(el);
    }

    this.chainElement = el.find('.'+this.options.chain);
    var chain = this.chainElement;
    if(this.options.isStatic) {
      chain.addClass('chain-static');
    }
    this._templateCreate(lineTplName, this.options.chainElements).insertBefore((el.find('.chain-finish')));
    this._templateCreate('nodeTemplate', this.options.nodeTemplateElements).appendTo(el.find(chainClass));
    this._templateCreate('nodeControls', this.options.nodeTemplateElements).appendTo(el.find(nodeTemplate));
    this._templateCreate('nodeContent', this.options.nodeTemplateElements).appendTo(el.find(nodeTemplate));
    this._templateCreate('nodeModal', this.options.nodeTemplateElements).appendTo(el.find(nodeTemplate));
    this._templateCreate('groupTemplate', this.options.groupTemplateElements).appendTo(el.find(chainClass));
    this._templateCreate(lineTplName, this.options.chainElements).appendTo(el.find(groupFirst));
    this._templateCreate(lineTplName, this.options.chainElements).appendTo(el.find(groupLast));

    if (this.options.canAddWatchers && !this.options.showNewDesign) {
      var watchersTpl = this._templateCreate('watchers');
    } else if (this.options.canAddWatchers && this.options.showNewDesign) {
      var watchersTpl = this._templateCreate('watchersList');
    } else {
      var watchersTpl = this._templateCreate('watchersLocked');
    }

    if (beforeElement) {
      watchersTpl.insertBefore(beforeElement);
    } else {
      watchersTpl.appendTo(el);
    }

    if($('.watcher-wrap.locked-watchers').length == 1) {
      if($('.locked-watchers .watcher-list li').size() == 0) {
        $('.watcher-wrap').addClass('empty-watchers');
      }
    }

    this._approverInit();
    var templateName;

    if(this.options.isStatic) {
      var nodeCount = el.find('.chain .chain-node').length,
          watcherCount = el.find('.unlocked-watchers .watcher-list li').size();
      if(nodeCount == 0) {
        var type = $('.approver-wrap').data('type');
        chain.addClass('empty-chain');
        switch (type) {
            case 'Invoice':
                templateName = 'emptyChainInvoice';
                break;
            case 'CreditMemo':
                templateName = 'emptyChainCreditMemo';
                break;
            case 'Order':
                templateName = 'emptyChain';
                break;
            default:
                templateName = 'emptyChain';
        }

        this._templateCreate(templateName).appendTo(chain);
        chain.parent().css('min-height','100%');
      }
      el.find('.watcher-wrap').addClass('watcher-static').find('h3').html(bq.messages.approvers.watchers);
      $.each(el.find($('.watcher-wrap')).find('.node-add').parent('li'), function(){
        $(this).remove();
      });

      if(watcherCount <= 1) {
        $('.watcher-wrap').addClass('empty-watchers');
      } else {
        $('.watcher-wrap').removeClass('empty-watchers');
      }
    }

    this.calibrate();
    this._provideAdditionalRules();
  },

  _isGroupApproved: function(node) {
    var isApproved = true;
    node.find('.chain-node').each(function (index, elem) {
      if (!$(elem).hasClass('chain-node-approved')) {
        isApproved = false;
      }
    });
    return isApproved;
  },

  _provideAdditionalRules: function() {
    var chain = this.$element.find('.chain');
    var nodes = chain.children().slice(1, chain.children().length - 3);
    var $this = this;
    var getNodeStatus = function(node) {
      var status = node.hasClass('chain-node-pending') ? 'chain-node-pending': '';
          status += node.hasClass('chain-node-approved') ? 'chain-node-approved': '';
          status += node.hasClass('chain-node-fixed') ? 'chain-node-fixed': '';
          return status;
    };

    var getNodeType = function(node) {
      var type = node.hasClass('chain-node') ? 'chain-node': '';
      type += node.hasClass('chain-group') ? 'chain-group': '';
      return type;
    };

    var isGroupHasAppovedOrPendingNodes = function (group) {
      return !!group.find('.chain-node-approved, .chain-node-pending').length;
    }

    var removeAddApproverButton = function (node) {
      node.find('.node-add').remove();
    }

    var cleanGroupe = function (group) {
      group.find('.group-row-ghost, .node-add').each(function (index, elem) {
        $(elem).remove();
      });
    }

    var iterator = function (index, node, elements, isGoupe) {
      var _node = $(node);
      switch (_node.attr('class').split(' ')[0]) {
        case bq.approvers.DEFAULTS.line:
          if (elements[index + 1]) {
            var nextNode = $(elements[index + 1]);
            if (getNodeType(nextNode) === 'chain-group' && isGroupHasAppovedOrPendingNodes(nextNode)) {
              removeAddApproverButton(_node);
            } else if (getNodeType(nextNode) === 'chain-node' &&
              (['chain-node-approved', 'chain-node-pending'].indexOf(getNodeStatus(nextNode)) > -1)
            ) {
              removeAddApproverButton(_node);
            }
          }
          if (elements[index - 1]) {
            var peviosNode = $(elements[index - 1]);
            if (getNodeType(peviosNode) === 'chain-group' && $this._isGroupApproved(peviosNode)) {
              removeAddApproverButton(_node);
            } else if (getNodeType(peviosNode) === 'chain-node' && getNodeStatus(peviosNode) === '.chain-node-approved') {
              removeAddApproverButton(_node);
            }
          }
        break;
        case bq.approvers.DEFAULTS.group:
          _node.find('.group-row').each(function (i, row) {
            var childrens = $(row).children();
            childrens.each(function (index, elem) {
              iterator(index, elem, childrens, true);
            });
          });
          if ($this._isGroupApproved(_node)) {
            cleanGroupe(_node);
          }
        break;
      }
    }
    nodes.each(function(index, node) {
        iterator(index, node, nodes);
    });

  },


  _chainClear: function() {
    bq.debug.log('Approvers: _chainClear()');

    var saveElement = null;
    if( this.$element.find('.chain-additional-data-after').length ) {
      saveElement = this.$element.find('.chain-additional-data-after').clone(true); // Need to deep-clone it to preserve listeners
    }

    var chainValueElement = null;
    if( this.$element.find('.approver-updated-data').length ) {
      chainValueElement = this.$element.find('.approver-updated-data');
    }

    this.$element.html('');

    if (chainValueElement) {
      chainValueElement.appendTo( this.$element );
    }

    if (saveElement) {
      saveElement.appendTo( this.$element );
    }
  },

  _chainSetNodes: function() {
    var nodes = this.$element.find('.'+this.options.chain).find('.'+this.options.node),
        nodeClass = '.'+this.options.node,
        firstNode = nodes.first(),
        lastNode = nodes.last(),
        firstNodeClass = this.options.groupNodeFirst,
        lastNodeClass = this.options.groupNodeLast,
        groupRow = this.$element.find('.'+this.options.groupRow);
    nodes.removeClass(this.options.nodeFirst)
            .removeClass(this.options.nodeLast)
              .removeClass(this.options.groupFirst)
                .removeClass(this.options.groupLast);
    firstNode.addClass(this.options.nodeFirst);
    lastNode.addClass(this.options.nodeLast);
    groupRow.children().removeClass(this.options.groupNodeFirst).removeClass(this.options.groupNodeLast).removeClass(this.options.nodeFirst).removeClass(this.options.nodeLast);
    groupRow.each(function(){
      $(this).find(nodeClass).first().addClass(firstNodeClass);
      $(this).find(nodeClass).last().addClass(lastNodeClass);
    });

    if($('.watcher-wrap.locked-watchers').length == 1) {
      if($('.locked-watchers .watcher-list li').size() == 0) {
        $('.watcher-wrap').addClass('empty-watchers');
      } else {
        $('.watcher-wrap').removeClass('empty-watchers');
      }
    }
  },

  _chainSetLines: function() {
    var chain = this.chainElement,
        approvalChain = this.$element.find('.'+this.options.approvalChain),
        lines = chain.find('.'+this.options.line),
        lineClass = this.options.line,
        lineClone = this.$element.find('.'+this.options.line).html(),
        nodes = chain.children('.'+this.options.node),
        nodeClass = this.options.node,
        ends = chain.find('.'+this.options.chainEnd),
        groups = chain.find('.'+this.options.group),
        groupRow = chain.find('.'+this.options.groupRow),
        groupsEnd = groups.find('.'+this.options.groupEnd),
        gradient = this.$element.parent().find('.'+this.options.overflow),
        height = this.$element.height(),
        chainPos = this.$element.position(),
        gradRight = this.$element.parent().find('.'+this.options.overflow + '-right'),
        gradLeft = this.$element.parent().find('.'+this.options.overflow + '-left');
    gradient.css('height', height+'px').css('top', chainPos.top+'px').hide();
    lines.css('min-width', '');
    lines.css('width', '');
    lines.css('padding-right','');

    $.each($('.'+lineClass), function(){
      $(this).next('.'+lineClass).remove();
    });

    var isNewDesign = this.getIsThemeNew();

    var elementWidth = this.$element.width();
    if (isNewDesign && approvalChain.length) {
      var chainPaddingLeft = parseFloat(approvalChain.css('padding-left')) || 0,
          chainPaddingRight = parseFloat(approvalChain.css('padding-right')) || 0;
      elementWidth = approvalChain.innerWidth() - chainPaddingLeft - chainPaddingRight;
    }

    var groupWidth = 0;
    groups.each(function() { groupWidth += $(this).width(); });
    var nodeWidth = nodes.length * nodes.width(),
        endsWidth = ends.length * ends.outerWidth(),
        groupsWidth = groupWidth + (groupsEnd.length * this.options.groupEndWidth),
        fullWidth = elementWidth - (endsWidth + nodeWidth + groupsWidth),
        directLine = chain.children('.'+this.options.line);

    if (isNewDesign && directLine.length && fullWidth > 0) {
      var newWidth = fullWidth / directLine.length;
      directLine.css('width', newWidth);
      directLine.css('min-width', newWidth);
    } else if (!isNewDesign && this.$element.width() > chain.width() && directLine.length && fullWidth > 0) {
      var newWidth = fullWidth / directLine.length;
      directLine.css('min-width', newWidth);
    }
    var line = '.'+this.options.line,
        node = '.'+this.options.node;
    groupRow.each(function(e) {
      var groupRow = $(this),
          groupRowWidth = groupRow.width(),
          groupLines = groupRow.find(line),
          groupLinesWidth = groupLines.length * groupLines.width(),
          groupNodes = groupRow.find(node),
          groupNodesWidth = groupNodes.length * groupNodes.width();
      groupLines.css('min-width','');
      if(groupRow.width() > (groupLinesWidth + groupNodesWidth)){
        var newGroupWidth = (groupRowWidth - groupNodesWidth) / groupLines.length;
        $.each(groupLines, function(){
          groupLines.css('min-width', newGroupWidth);
        });
      };
    });
    if(chain.width() > (isNewDesign ? elementWidth : this.$element.width())) {
      gradRight.show();
      var elem = this.$element,
          inner = chain;
      elem.scroll(function() {
        gradLeft.show();
        if(elem.scrollLeft() + elem.width() == inner.width()) {
          gradRight.hide();
        } else if(elem.scrollLeft() == 0){
          gradLeft.hide();
        } else {
          gradRight.show();
        }
      });
    } else {
      gradient.hide();
    }
  },

  _chainUpdate: function(e, data) {
    bq.debug.log('Approvers: _chainUpdate', e, 'Data: ', data);
    var $this = e.data.context;
    $this.approverData = data;
    $this._chainClear();
    $this._chainBuild();
    $this.calibrate();
  },

  _groupAddLine: function(e) {
    bq.debug.log('Approvers: _groupAddLine()', e);
    var groupRowClass = '.'+this.options.groupRow,
        thisClone = e.parents('.'+this.options.groupRowGhost),
        ghostClone = this.$element.find('.'+this.options.groupTemplate).find('.'+this.options.groupRowGhost).html(),
        groupRow = this.$element.find('.'+this.options.groupTemplate).find(groupRowClass).html();
    $(thisClone).addClass('group-row').removeClass(this.options.groupRowGhost).html(groupRow);
    var clonePos = $(thisClone).index(),
        group = $(thisClone).parent('.'+this.options.group);
    group.children('div:eq('+clonePos+')').before('<div class="'+this.options.groupRowGhost+'">'+ghostClone+'</div>').after('<div class="'+this.options.groupRowGhost+'">'+ghostClone+'</div>');
  },

  _groupCleanUp: function() {
    bq.debug.log('Approvers: _groupCleanUp()');
    var group = this.$element.find('.'+this.options.chain).find('.'+this.options.group),
        row = '.'+this.options.groupRow,
        node = '.'+this.options.node,
        groupFirstClass = this.options.groupFirst,
        groupLastClass = this.options.groupLast,
        groupNodeLastClass = this.options.groupNodeLast,
        groupNodeFirstClass = this.options.groupNodeFirst,
        ghost = '.'+this.options.groupRowGhost,
        line = '.'+this.options.line,
        lineClass = this.options.line,
        lineClone = this.$element.find('.'+this.options.line).html();
    group.each(function(){
      var thisGroup = $(this);
      thisGroup.find(row).each(function(){
        if($(this).find(node).length === 0) {
          if($(this).hasClass(groupFirstClass)) {
            $(this).next(ghost).remove();
            $(this).remove();
          } else if($(this).hasClass(groupLastClass)) {
            $(this).prev(ghost).remove();
            $(this).remove();
          } else {

          }
        }
      });
      if(thisGroup.find(node).length === 0) {
        $(this).remove();
      }
      if(thisGroup.find(row).length === 1) {
        $(this).find(node).each(function(){
          var thisNode = $(this),
              thisNodeClone = thisNode.html();
          thisNode.insertBefore(thisGroup);
          thisNode.after('<div class="'+lineClass+'">'+lineClone+'</div>');
          $(this).removeClass(groupNodeFirstClass+' '+groupNodeLastClass);
        });
        thisGroup.remove();
      }
    });
  },

  _groupSetRows: function() {
    var chain = this.chainElement,
        group = chain.find('.'+this.options.group),
        groupRow = '.'+this.options.groupRow,
        groupFirstClass = this.options.groupFirst,
        groupLastClass = this.options.groupLast;
    group.each(function(){
      $(this).find(groupRow).first().addClass(groupFirstClass);
      $(this).find(groupRow).last().addClass(groupLastClass);
      $(this).find('.'+groupLastClass).next('.group-row-ghost').remove();
    });
  },

  _updateApproverDataInput: function() {
    var element = this.$element;
    var input = element.find('input[name="' + element.data('update-name') + '"]');
    if (input) {
      input.val(JSON.stringify(this.updatedApproverData));
    }
  },

  _modalClose: function(e){
    bq.debug.log('Approvers: _modalClose()', e);
    var $this = e.data.context,
        chain = $this.chainElement;
    if($this.addModal) {
        $this.addModal.hide();
        $this.$element.removeClass('chain-modal-shown');
    }
    chain.removeClass('add-modal');
    $this.addModalVisible = false;
    $this.$element.find('#people_search_key').val('');
    $this.$element.find('.users.source-list').empty();
    $this.$element.find('.approval-chain-results').hide();
    $this.people_filter = [];
  },

  _modalCreate: function() {
    bq.debug.log('Approvers: _modalCreate()');
    var approvalChain = this.$element.find('.'+this.options.approvalChain),
        url = this.options.approverList;
    if (this.options.approvalManual) {
        var approvalTemplate = this.options.approvalReasonOptional ? 'approvalAddOptionalReason' : 'approvalAddManual';
    } else {
        var approvalTemplate = 'approvalAdd';
    }

    this.addModal = this._templateCreate(approvalTemplate).appendTo(approvalChain);
    if (this.modalType === 'watcher') {
        if (url.indexOf('?') > -1) {
            url += '&';
        } else {
            url += '?';
        }
        url += 'watcher=1';
    }
    this._catchSelect2Change(this.options.customerId, url);
    approvalChain.on('click', '.approval-add .close', {context: this}, this._modalClose);
  },

  _modalClearDisplay: function() {
    bq.debug.log('Approvers: _modalClearDisplay()');
    var approvalChain = this.$element.find('.'+this.options.approvalChain);
    approvalChain.find('.approval-add').remove();
  },

   _modalPosition: function(){
    var chain = this.chainElement,
        left = (this.$element.width() / 2) - (this.addModal.outerWidth() / 2),
        top = chain.position().top + (chain.height() / 2) - 50;
    chain.addClass('add-modal');
    this.$element.addClass('chain-modal-shown');
    this.addModal.css({'top': top+'px', 'left': left+'px'}).show();
  },

  _nodeAdd: function(e, location) {
    bq.debug.log('Approvers: _nodeAdd()', e, location);
    var node = this.$element.find('.'+this.options.nodeTemplate).clone(),
        line = location;
    var nodeId = 'A_' + e.customer;
    if (e.type == 'group') {
        nodeId = 'AG_' + e.group;
    }

    var nodeData = (this.options.showNewDesign ? '<div class="approver-action"></div>' : '') + '<img src="' + e.img + '" alt="' + e.name + '" />';
    node.removeClass(this.options.nodeTemplate)
        .addClass(this.options.node)
        .attr('data-node-id', nodeId)
        .find('.'+this.options.nodeContent)
        .append(nodeData)
        .append('<div class="approver-name">' + e.name + '</div>');

    node.find('.node-name').html(e.name);
    node.find('.node-role').html(e.role);
    if(e.reason) {
      node.find(this.options.nodeReasonSelector).html(e.reason);
    }
    if(!e.reason) {
      node.find('.node-reason strong').html('');
    }
    if(e.status_date) {
      node.find('.node-date span').html(e.status_date);
        if(data.status == 4) {
          modal.find('.node-date strong').html(bq.messages.approvers.declinedDate);
        }
    } else {
      node.find('.node-date').remove();
    }
    if(e.processed_by) {
      node.find('.node-processor span').html(e.processed_by);
    } else {
      node.find('.node-processor').remove();
    }

    if (e.customer) {
      if (e.data) {
        $.each(e.data, function(content) {
          node.find('.node-contact').append('<a class="node-icon" target="_blank" title="'+e.data[content].title+'" href="'+e.data[content].url+'"><span class="'+e.data[content].icon+'"></span></a>');
        });
      }
    } else if (e.group) {
      if (e.view_url && e.view_title) {
        node.find('.node-info').append('<div class="view_members"><a href="javascript:void(0);" onclick="javascript:bq.helper.ajaxModal(\'' + e.view_url + '\',\'modal-short\')">' + e.view_title + '</a></div>');
      }
    }

    line.after(line.clone()).after(node);
    this.calibrate();

    return nodeId;
  },

  _addApproverPopovers: function(node) {
     var _this = this;
     if (node) {
       this._addPopover(node.find('.node-content'), node.find('.popover-html'));
     } else {
       $('.approval-chain .chain-node').each(function() {
         _this._addPopover($(this).find('.node-content'), $(this).find('.popover-html'));
       });
     }
  },

  _hidePopovers: function () {
    $('.approval-chain .chain-node .node-content').popover('hide');
  },

  _nodeCleanUp: function() {
    var nodes = this.$element.find('.'+this.options.node);
    $.each(nodes, function(){
      if($(this).find('.node-content').is(':empty')) {
        $(this).remove();
      }
    });
    this._groupCleanUp();
  },

  _nodeDelete: function(e) {
    bq.debug.log('Approvers: _nodeDelete()', e);
    var $this = e.closest('.'+this.options.node),
        id = $this.data('nodeId');
    $this.remove();
    var pos = this.manualNodeIds.indexOf(id);
    if (pos !== -1) {
        this.manualNodeIds.splice(pos, 1);
    }
    this._groupCleanUp();

    if (this.options.approvalManual) {
      this._defineDefaultApprovers();
    }
    this._updateSubmitState();
  },

  _nodeLoad: function(id, data) {
    var $this = this,
        element = this.$element,
        chain = this.chainElement,
        dataID = element.find(chain).find('.chain-node[data-node-id="'+id+'"]'),
        node = element.find(chain).find(dataID),
        watcherID = element.find('li[data-watcher-id="'+id+'"]'),
        watcher = element.find(watcherID),
        modal = node.find('.'+this.options.modal),
        nodeClass = this.options.node,
        isStatic = $this.options.isStatic,
        custIcon = this.options.userIcon,
        groupIcon = this.options.groupIcon;
    if(!data.img){
      if(data.customer) {
        data.img = custIcon;
      } else if(data.group) {
        data.img = groupIcon;
      }
    }
    //LOAD APPROVERS
    if(!node.attr('data-init')) {
      var content = chain.find(dataID).find('.node-content');
      var nodeContent = (this.options.showNewDesign ? '<div class="approver-action"></div>' : '') + '<img src="' + data.img + '" alt="' + data.name + '" />';
      content
          .append(nodeContent)
          .append('<div class="approver-name">' + data.name + '</div>');
      modal.find('.node-name').html(data.name);
      modal.find('.node-role').html(data.role);
      if(data.reason) {
        modal.find($this.options.nodeReasonSelector).html(data.reason);
      }
      if(!data.reason) {
        modal.find('.node-reason strong').html('');
      }
      if(data.status_date) {
        modal.find('.node-date span').html(data.status_date);
        if(data.status == 4) {
          modal.find('.node-date strong').html(bq.messages.approvers.declinedDate);
        }
      } else {
        modal.find('.node-date').remove();
      }
      if(data.processed_by) {
        modal.find('.node-processor span').html(data.processed_by);
      } else {
        modal.find('.node-processor').remove();
      }
      if (data.customer) {
        $.each(data.data, function(content) {
          var contactType =  data.data[content].type ? data.data[content].type : '';
          modal.find('.node-contact').append('<a class="node-icon ' + contactType + '" target="_blank" title="'+data.data[content].title+'" href="'+data.data[content].url+'"><span class="'+data.data[content].icon+'"></span></a>');
        });
      } else {
        if (data.view_url && data.view_title) {
          modal.find('.node-info').append('<div class="view_members"><a href="javascript:void(0);" onclick="javascript:bq.helper.ajaxModal(\'' + data.view_url + '\',\'modal-short\')">' + data.view_title + '</a></div>');
        }
      }
      switch (data.status) {
        case 1:
          node.addClass('chain-node-pending');
          node.find('.node-action').remove();
          node.find('.node-controls').remove();
          break;
        case 2:
          node.addClass('chain-node-fixed');
          node.find('.node-action').remove();
          node.find('.node-controls').remove();
          break;
        case 3:
          node.addClass('chain-node-approved');
          node.find('.node-action').remove();
          node.find('.node-controls').remove();
          break;
        case 4:
          node.addClass('chain-node-rejected');
          node.find('.node-action').remove();
          node.find('.node-controls').remove();
          break;
      }

      //code for adding select2 dropdown to node if additiona choices are available
      $this._proccessAdditionalChoices(node, id);

      node.attr('data-init','true');
    }

    // LOAD WATCHERS
    var watcherData = {};
    if(!data.name) {
      watcherData.watcherName = '';
    } else {
      watcherData.watcherName =  data.name;
    }

    watcherData.watcherImg = data.img;

    var watcherElement = $this._templateCreate('watcherData', watcherData);
    if (!this.options.canAddWatchers || Array.isArray(data.rule_ids)) {
        watcherElement.find('.node-action-delete').attr("style", "display: none !important");
    }
    watcherElement.appendTo(watcher);

    var watcherPopover = $this._templateCreate('watcherModal', this.options.nodeTemplateElements);

    watcherPopover.find('.node-name').html(data.name);
    watcherPopover.find('.node-role').html(data.role);
    if(data.reason) {
      watcherPopover.find($this.options.nodeReasonSelector).html(data.reason);
    }
    if(data.status_date) {
      watcherPopover.find('.node-date span').html(data.status_date);
        if(data.status == 4) {
          modal.find('.node-date strong').html(bq.messages.approvers.declinedDate);
        }
    } else {
      watcherPopover.find('.node-date').remove();
    }
    watcherPopover.find('.node-processor').remove();

    if (data.customer) {
      $.each(data.data, function(content) {
        watcherPopover.find('.node-contact').append('<a class="node-icon" target="_blank" title="'+data.data[content].title+'" href="'+data.data[content].url+'"><span class="'+data.data[content].icon+'"></span></a>');
      });
    } else {
      if (data.view_url && data.view_title) {
        watcherPopover.find('.node-info').append('<div class="view_members"><a href="javascript:void(0);" onclick="javascript:bq.helper.ajaxModal(\'' + data.view_url + '\',\'modal-short\')">' + data.view_title + '</a></div>');
      }
    }

    if (data.fixed) {
      $(watcherPopover).find('.node-action').remove();
      $(watcherPopover).css('cursor','default');
    }

    this._addPopover(watcherElement, watcherPopover);

    $('.approver-wrap').parents('.section-content').css('padding', '0');
  },

  _addPopover: function (el, content) {
    var $watcherElement = $(el),
        timeout = null;

    $watcherElement.popover({
      html: true,
      content: content.html(),
      placement: $watcherElement.attr('data-placement') || 'top',
      trigger: 'click',
      stopHidePropagation: true,
      container: 'body'
    });

    $watcherElement.on('click', function (e) {
      var $this = $(this);
      var isDeleteClick = $(e.target).closest('.watcher-delete-wrap, [data-action="delete"]').length > 0;

      // Keep delete action behavior, but do not show the popover for this click.
      if (isDeleteClick) {
        $this.popover('hide');
        return;
      }

      clearTimeout(timeout);

      timeout = setTimeout(function () {
        $this.popover('hide');
      }, 4000);

      $('.approval-chain .chain-node .node-content[data-toggle="popover"]').not($(this)[0]).popover('hide');
    });
  },

  _proccessAdditionalChoices: function(node, id) {

    if(!this.approverData.alternate_choices || this.options.isStatic) { return; }
    var name = node.find('h6');
    var state = node.find('.node-state');
    var modal = node.find('.node-modal');

    if(this.approverData.alternate_choices[id]) {
        var choices = this.approverData.alternate_choices[id];
        if(choices.search && choices.url) {

            var link = $('<a class="node-action node-action-edit" href="javascript:void(0);" data-action="nodeedit"><span class="fa"></span></a>');
            link.data('parent', id);
            link.data('url', choices.url);
            link.data('title', choices.title);
            state.after(link);


            //state.remove();

        } else if(choices.choices) {
            var select = $('<select name="tmp_select_box_'+id+'" class="node-alternate-select"></select>');

            $.each(choices.choices, function(k,v){
                var o = $('<option value="choice_'+id+'_'+k+'"></option>');
                o.data('data-record', v);
                o.data('parent', id);
                o.text(v.name);
                if(v["default"]) {
                    o.attr('selected','selected');
                }

                select.append(o);
            });

            select = $('<div style="margin: -18px 20px 2px;"></div>').append(select);

            var changeLink = '<a href="javascript:void(0);" class="small text-center approver-edit-additional">'+bq.messages.approvers.change+'</a>';
            modal.find('.node-modal-header').after(select);
            name.after(changeLink);

            //name.addClass('hide');
            select.find('select').select2();
        }
    }
  },

  _nodeModalDisplay: function(e) {
    bq.debug.log('Approvers: _nodeModalDisplay()', e);
    var $this = e.data.context,
        node = e.parent('.'+this.options.node),
        approvalChain = e.parents('.'+this.options.approvalChain),
        watcherChain = e.parents('.'+this.options.watcherList);
    this._nodeModalHide();
    approvalChain.addClass('open-modal');
    watcherChain.addClass('open-modal');
    node.addClass(this.options.modalClass);
  },

  _nodeModalHide: function() {
    var approvalChain = this.$element.find('.'+this.options.approvalChain),
        watcherChain = this.$element.find('.'+this.options.watcherList);
    if(approvalChain.hasClass('open-modal')) {
      bq.debug.log('Approvers: _nodeModalHide()');
      var chain = this.chainElement,
          modals = chain.find('.'+this.options.node+'.'+this.options.modalClass);
      modals.removeClass(this.options.modalClass);
      approvalChain.removeClass('open-modal');
    }
    if(watcherChain.hasClass('open-modal')) {
      var watcherModal = watcherChain.find('.'+this.options.modalClass);
      watcherModal.removeClass(this.options.modalClass);
      watcherChain.removeClass('open-modal');
    }
  },

  _nodeMoveHorizontal: function(element, direction) {
    bq.debug.log('Approvers: _nodeMoveHorizontal()', element, direction);
    var $this = element.parents('.'+this.options.node),
        nodeID = $this.data('nodeId'),
        nodeRow = $this.parents('.'+this.options.groupRow),
        lineClone = this.$element.find('.'+this.options.line).has('.node-add').html();
    if($this.parent().hasClass(this.options.groupRow)) {
      if(((direction === 'left') ? $this.hasClass(this.options.groupNodeFirst) : $this.hasClass(this.options.groupNodeLast))) {
        // MOVE OUT OF PARALLEL GROUP
        if ($this.hasClass(this.options.groupNodeFirst) && direction === 'left') {
          var parentGroupe = $this.parent().parent();
          if (parentGroupe.prev().hasClass('chain-line')) {
            if (parentGroupe.prev().prev().hasClass('chain-group') && this._isGroupApproved(parentGroupe.prev().prev())) {
              return;
            }
          }
        }
        ((direction === 'left') ? $this.insertBefore(nodeRow.parent()) : $this.insertAfter(nodeRow.parent()));
        ((direction === 'left') ? $this.after('<div class="'+this.options.line+'">'+lineClone+'</div>') : $this.before('<div class="'+this.options.line+'">'+lineClone+'</div>'));
        $this.removeClass(this.options.groupNodeLast).removeClass(this.options.groupNodeFirst);
      } else {
        // IN PARALLEL GROUP SWITCH WITH APPROVER ON LINE
        var nextNode = ((direction === 'left') ? $this.prev().prev() : $this.next().next());
        if (nextNode.hasClass('chain-node-pending') || nextNode.hasClass('chain-node-approved')) {
          return;
        }
        $this.insertAfter(((direction === 'left') ? $this.prev().prev().prev() : $this.next().next().next()));
        ((direction === 'left') ? $this.after('<div class="'+this.options.line+'">'+lineClone+'</div>') : $this.after('<div class="'+this.options.line+'">'+lineClone+'</div>'));
      }
    } else {
      if(((direction === 'left') ? $this.prev().prev() : $this.next().next()).hasClass(this.options.group)) {
        // ADD NODE TO PARALLEL GROUP
        var row = ((direction === 'left') ? $this.prev().prev() : $this.next().next()).find('.'+this.options.groupFirst),
            node = ((direction === 'left') ? row.find('.'+this.options.line).last() : row.find('.'+this.options.line).first());
        ((direction === 'left') ? $this.insertAfter(node) : $this.insertBefore(node));
        ((direction === 'left') ? $this.after('<div class="'+this.options.line+'">'+lineClone+'</div>') : $this.before('<div class="'+this.options.line+'">'+lineClone+'</div>'));
      } else {
        // TURN INTO A PARALLEL GROUP
        var newGroup = this.$element.find('.'+this.options.groupTemplate),
            newRow = newGroup.find('.'+this.options.groupRow),
            nextNode = ((direction === 'left') ? $this.prev().prev() : $this.next().next()),
            nextNodeID = nextNode.data('nodeId'),
            nextNodeClone = nextNode.html();
        if(!nextNode.hasClass('chain-node-fixed')){
          if (nextNode.hasClass('chain-node-pending') || nextNode.hasClass('chain-node-approved')) {
            return;
          }
          nextNode.remove();
          ((direction === 'left') ? $this.prev() : $this.next()).after('<div class="'+this.options.group+' tempGrp">'+newGroup.html()+'</div>');
          var currentGroup = this.$element.find('.tempGrp'),
              topNodePos = currentGroup.find('.'+this.options.groupFirst),
              bottomNodePos = currentGroup.find('.'+this.options.groupLast);
          $this.remove();
          topNodePos.append('<div class="'+this.options.node+'" data-node-id="'+nodeID+'">'+$this.html()+'</div><div class="'+this.options.line+'">'+lineClone+'</div>');
          bottomNodePos.append('<div class="'+this.options.node+'" data-node-id="'+nextNodeID+'">'+nextNodeClone+'</div><div class="'+this.options.line+'">'+lineClone+'</div>');
          currentGroup.removeClass('tempGrp');
        } else {
          // NEXT TO FIXED NODE SWITCH POSITIONS (NO PARALLEL)
          var nextNode = ((direction === 'left') ? $this.prev().prev() : $this.next().next());
          $this.insertAfter(((direction === 'left') ? $this.prev().prev().prev() : $this.next().next().next()));
          ((direction === 'left') ? $this.after('<div class="'+this.options.line+'">'+lineClone+'</div>') : $this.after('<div class="'+this.options.line+'">'+lineClone+'</div>'));
        }
      }
    }
    this._groupCleanUp();
    this._buildJsonSave();
    this._updateApproverDataInput();
  },

  _nodeMoveVertical: function (element, direction) {
    bq.debug.log('Approvers: _nodeMoveVertical()', element, direction);
    var $this = element.parents('.'+this.options.node),
        nodeIndex = $this.index(),
        nodeClone = $this.html(),
        nodeRow = $this.parents('.'+this.options.groupRow),
        nextRow = ((direction === 'up') ? nodeRow.prev().prev() : nodeRow.next().next()),
        rowChildren = nextRow.children(),
        nextRowNode = nextRow.find('.'+this.options.groupNodeFirst),
        lineClone = this.$element.find('.'+this.options.line).has('.node-add').html();
        var pos = rowChildren.last();
    $this.insertAfter(pos);
    $this.after('<div class="'+this.options.line+'">'+lineClone+'</div>');
    this._groupCleanUp();
  },

  _select2ApplyStyling: function(list) {
    bq.debug.log('Approvers: _select2ApplyStyling()', list);
    var tracker = true;
    list.find('li').each(function() {
      var elm = jQuery(this);
      if(elm.attr('id') == 'person_0') {
        elm.hide();
      }
      if(elm.hasClass('hide-forever')) {
        return;
      }
      if(tracker) {
        elm.removeClass('alternate');
      } else {
        elm.addClass('alternate');
      }
      tracker = !tracker;
    });
    this._select2UpdateVis();
  },

  _select2BuildList: function(records, list, id_prefix, id_index, second_span_index) {
    bq.debug.log('Approvers: _select2BuildList()', 'records: ', records, ' list: ', list, ' id_prefix: ', id_prefix, ' id_index: ', id_index, ' second_span_index: ',second_span_index);
    var $this = this,
        chain = this.chainElement;
    $.each(records, function() {
      var index = id_index;
      if(!('segment_id' in this) && this['entity_id'] in $this.people_filter) {
        extra_class = ' hide-forever';
      }

      if(!this[index]) {
	      index = 'id';
      }

      var extra_class = '',
          select2Elements = {
            liId: id_prefix + this[index],
            liClass: 'skip-counting-me' + extra_class,
            data: JSON.stringify(this),
            divClass: 'skip-counting-me',
            userId: this[id_index],
            userImg: this['img'],
            userName: this['name'],
            userEmail: this[second_span_index]
          };
      $this._templateCreate('select2List', select2Elements).appendTo(list);
    });

    this._select2UpdateVis();
  },

  _select2Search: function(e, url) {
    bq.debug.log('Approvers: _select2Search()', e, ' url: ', url);
    var $this = this,
        el = this.$element;
    if(this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      if(this.xhr) {
        this.xhr.abort();
      }
    }
    this.timeoutHandler = setTimeout(function() {
    var search = el.find('#people_search_key').val();
    if(!search || search.length < 2) {
      return;
    }

    if($this.modalType === 'approver' && $this.modalMode === 'edit' && $this.modalEditUrl) {
        url = $this.modalEditUrl;
    }

    el.xhr = jQuery
      .ajax(url, {
        data: {
          search: search,
          '_': new Date().getTime()
        },
        dataType: 'json'
      })
      .done(function(response) {
        var list = el.find('.users.source-list');
        list.empty(); // Clear the list
        $this._select2BuildList(response, list, 'person_', 'customer', 'email');
        list.find('li').addClass('show-source');
        $this._select2ApplyStyling(list);
      })
      .fail(function(response, status, error) {})
      .always(function() {});
    }, 400);
  },

  _select2UpdateVis: function() {
    bq.debug.log('Approvers: _select2UpdateVis()');
    jQuery('.source-list').each(function() {
      var count = 0,
          tmp = jQuery(this);
      jQuery('li', tmp).each(function() {
        if(!jQuery(this).hasClass('hide-forever')) {
          count++;
        }
      });
      if(count >= 1) {
        tmp.parent().show();
      } else {
        tmp.parent().hide();
      }
    });
  },

  _templateCreate: function(template, templateVars) {
    bq.debug.log('Approvers: _templateCreate()', template, templateVars);
    return $.tmpl(template, templateVars);
  },

  _watcherAdd: function(e) {
    bq.debug.log('Approvers: _watcherAdd()', e);
    var list = e.parent().find('ul');
    this._catchWatcherAdd(list);
  },

  _watcherCreate: function(e) {
    bq.debug.log('Approvers: _watcherCreate()', e);

    let watcherId = 'W_' + e.customer;
    if (e.type === 'group') {
        if (e.customer_segment_id !== undefined) {
            watcherId = 'WG_' + e.customer_segment_id;
        } else{
            watcherId = 'WG_' + e.group;
        }
    }

    let list = this.$element.find('.'+this.options.watcherList),
        add = list.find('.node-add').parent('li'),
        watcherData = {
            watcherImg: e.img,
            watcherName: e.name
        };

    this._templateCreate('watcherBlank').insertBefore(add);
    let watcher = list.find('li:nth-last-child(2)');
    let watcherElement = this._templateCreate('watcherData', watcherData);
    if (!this.options.canAddWatchers) {
        watcherElement.find('.node-action-delete').attr("style", "display: none !important");
    }
    watcherElement.appendTo(watcher);

    let watcherPopover = this._templateCreate('watcherModal', this.options.nodeTemplateElements);
    watcher.attr('data-watcher-id', watcherId);
    watcherPopover.find('.node-name').html(e.name);
    watcherPopover.find('.node-role').html(e.role);
    if (e.reason) {
        watcherPopover.find(this.options.nodeReasonSelector).html(e.reason);
    }

    if (e.customer) {
        $.each(e.data, function(content) {
            watcherPopover.find('.node-contact')
                .append('<a class="node-icon" target="_blank" title="'+e.data[content].title+'" href="'+e.data[content].url+'"><span class="'+e.data[content].icon+'"></span></a>');
        });
    } else {
        if (e.view_url && e.view_title) {
            watcherPopover.find('.node-info')
                .append('<div class="view_members"><a href="javascript:void(0);" onclick="javascript:bq.helper.ajaxModal(\'' + e.view_url + '\',\'modal-short\')">' + e.view_title + '</a></div>');
        }
    }

    if (e.fixed) {
        watcherPopover.find('.node-action').remove();
        watcherPopover.css('cursor','default');
    }

    this._addPopover(watcherElement, watcherPopover);
    this.calibrate();
    return watcherId;
  },

  _watcherRemove: function(e) {
    bq.debug.log('Approvers: _watcherRemove()', e);
    var item = e.parent('li'),
        id = parseInt(item.data('watcherId'));
    item.remove();
    this.calibrate();
  },

  _nodeEdit: function(data, link, e) {
    var $this = this,
        parentId = link.data('parent');

    var nodeId = 'A_' + data.customer;
    if (data.type == 'group') {
        nodeId = 'AG_' + data.group;
    }

    if($this.approverData.nodes[0][parentId]) {
        var updatedNode = $.extend($this.approverData.nodes[0][parentId], data);

        $this.approverData.nodes[0][nodeId] = updatedNode;

        if($this.approverData.alternate_choices[parentId]) {
            $this.approverData.alternate_choices[nodeId] = $this.approverData.alternate_choices[parentId];
        }

        $.each($this.approverData.approvers, function(k,v){
            if(v instanceof Array) {
                $.each($this.approverData.approvers[k], function(k2,v2){
                   if(v2 == parentId) {
                       $this.approverData.approvers[k][k2] = nodeId;
                   }
                });
            } else {
                if(v == parentId) {
                    $this.approverData.approvers[k] = nodeId;
                }
            }
        });

        $this._chainUpdate(e, $this.approverData);
    }
  },

  _updateManualNodeAction: function() {
    var _this = this,
      processed = [];

    _this.manualNodeIds.forEach(function(e) {
      if (processed.indexOf(e) === -1) {
        processed.push(e);
        var node = $('[data-node-id="' + e + '"]');
        node.each(function() {
          var $prevNode = $(this).prev().prev();
          var prevNodeFixed = $prevNode.hasClass('chain-node-fixed');
          var prevNodeChainStart = $prevNode.hasClass(_this.options.chainStart);
          var prevNodeFirst = $prevNode.hasClass(_this.options.nodeFirst)
            || $prevNode.hasClass(_this.options.groupFirst);

          if (prevNodeFirst && prevNodeFixed || prevNodeChainStart) {
            $(this).find('.node-controls .move-left').hide();
          } else {
            $(this).find('.node-controls .move-left').show();
          }
        });
      }
    });
  },

  // CATCH METHODS *******************************************

  _catchApproverSave: function(e, target) {
    bq.debug.log('Approvers: _catchApproverSave()', e);
    var $this = e.data.context;
    target = $(target);
    if(target && target.is('input')) {
      $this._buildJsonSave();
      target.val(JSON.stringify($this.updatedApproverData));
      bq.debug.info('Approvers: updatedApproverData', $this.updatedApproverData);
      bq.debug.info('Approvers: updatedApproverData JSON', target.val());
    } else if(target) {
      bq.debug.warn('Approvers: Target is not an input');
    }
  },

  _catchCalibrate: function(e) {
    bq.debug.log('Approvers: _catchCalibrate()', e);
    var $this = e.data.context;
    $this.calibrate();
  },

  _catchDocumentClick: function(e){
    bq.debug.log('Approvers: _catchDocumentClick()', e);
    var $this = e.data.context;
    if($this.eventChange == false) {
      $this._nodeModalHide();
    }
    $this.eventChange = false;
  },

  _catchEventChange: function(e) {
    var $this = e.data.context,
        el = $(e.currentTarget),
        action = el.data('action'),
        confirm = (el.data('bq') == 'confirm-dialog');
    if (confirm) {
        return false;
    }

    bq.debug.log('Approvers: (action)', action);
    $this.eventChange = true;
    $this._nodeModalHide();
    if(!$this.addModalVisible) {
      $this._hidePopovers();
      switch(action) {
        case 'watcherAdd':
          $this._watcherAdd(el);
          break;
        case 'watcherRemove':
          $this._watcherRemove(el);
          break;
        case 'delete':
          $this._nodeDelete(el);
          break;
        case 'add':
          $this._catchNodeAdd(e, el);
          break;
        case 'nodeedit':
          $this._catchNodeEdit(e, el);
          break;
        case 'modal':
          $this._nodeModalDisplay(el);
          break;
        case 'addLine':
          $this._groupAddLine(el);
          break;
        case 'up':
          $this._nodeMoveVertical(el,'up');
          break;
        case 'down':
          $this._nodeMoveVertical(el,'down');
          break;
        case 'left':
          $this._nodeMoveHorizontal(el,'left');
          break;
        case 'right':
          $this._nodeMoveHorizontal(el,'right');
          break;
        default:
          bq.debug.warn('Approvers: Unknown Event', e);
      }
    }
    $this.calibrate();
  },

  _catchModalAddElement: function(e) {
    bq.debug.log('Approvers: _catchApproverAdd()', e);
    var $this = e.data.context,
        target = $this.currentTarget,
        data = JSON.parse($(this).attr('data-record'));
    if($this.modalType == 'approver' && $this.modalMode !== 'edit') {
      $this._nodeAdd(data, target.parent());
    } else if($this.modalType == 'approver' && $this.modalMode === 'edit') {
      $this._nodeEdit(data, target, e);
    } else {
      $this._watcherCreate(data);
    }
    $this._modalClose(e);
  },

  _catchNodeAdd: function(e, target) {
    bq.debug.log('Approvers: _catchNodeAdd()', target);
    var $this = e.data.context;
    $this.currentTarget = target;
    $this.addModalVisible = true;
    $this.modalType = 'approver';
    if(!$this.addModal) {
      $this._modalCreate();
    } else {
      $this._modalClearDisplay();
      $this._modalCreate();
    }
    $this.modalMode = 'add';
    $this.$element.find('.add-modal-title').html(bq.messages.approvers.addApprover);
    $this._modalPosition();
  },

  _catchNodeEdit: function(e, target) {
    bq.debug.log('Approvers: _catchNodeEdit()', target);
    var $this = e.data.context;
    $this.currentTarget = target;
    $this.addModalVisible = true;
    $this.modalType = 'approver';
    if(!$this.addModal) {
      $this._modalCreate();
    } else {
      $this._modalClearDisplay();
      $this._modalCreate();
    }
    $this.modalMode = 'edit';
    $this.modalEditUrl = target.data('url');
    var title = bq.messages.approvers.editApprover;
    if(target.data('title')) {
        title = target.data('title');
    }
    $this.$element.find('.add-modal-title').html(title);
    $this._modalPosition();
  },

  _catchResizeEvent: function(e) {
    bq.debug.log('Approvers: resizeEvent()');
    var $this = e.data.context;
    function resizeDone() {
      $this.calibrate();
    }
    clearTimeout($this.options.resizeId);
    $this.options.resizeId = setTimeout(resizeDone, 500);
  },

  _catchSelect2Change: function(custId, url) {
    bq.debug.log('Approvers: _catchSelect2Change(): custId: ', custId, ' url: ', url);
    var $this = this;
    $this.people_filter[custId] = true;
    $this.people_filter[0] = true;
    this.$element.find('#people_search_key').change(function(e) {
      if (!e.target.value) {
        const manualSubmitButton = $this.$element.find('.approval-add-manual button[type="submit"]');

        if (!manualSubmitButton.hasClass('disabled')) {
          manualSubmitButton.addClass('disabled');
        }

        return;
      }
      if (!this.allowLoadResultList) {
        this.allowLoadResultList = true;

        return;
      }
      $this._select2Search(e, url);
    }).keyup(function(e) {
      $this._select2Search(e, url);
    });
    this.$element.find('.approval-chain-search span.form-control-feedback').click(function(e) {
      $this._select2Search(e, url);
    });
  },

  _catchWatcherAdd: function(e) {
    bq.debug.log('Approvers: _catchWatcherAdd()');
    var $this = e.data.context;
    if(this.currentTarget) {
      this.currentTarget = false;
    }
    this.addModalVisible = true;
    this.modalType = 'watcher';
    if(!this.addModal) {
      this._modalCreate();
    } else {
      this._modalClearDisplay();
      this._modalCreate();
    }
    this.$element.find('.add-modal-title').html(bq.messages.approvers.addWatcher);
    this._modalPosition();
  },

  _catchHiddenBootstrapModal: function(e) {
    bq.debug.log('Approvers: _catchHiddenBootstrapModal()');
    var $this = e.data.context;
    $this.calibrate();
  },

  _catchAdditionalChange: function(e) {
    var $this = e.data.context,
        $el = $(this),
        val = $el.val(),
        option = $el.find('[value="'+val+'"]'),
        newData = option.data('data-record'),
        parentId = option.data('parent');

    if($this.approverData.nodes[0][parentId]) {
        var updatedNode = $.extend($this.approverData.nodes[0][parentId], newData);

        var nodeId = 'A_' + newData.customer;
        if (newData.type == 'group') {
            nodeId = 'AG_' + newData.group;
        }

        $this.approverData.nodes[0][nodeId] = updatedNode;

        if($this.approverData.alternate_choices[parentId]) {
            $this.approverData.alternate_choices[nodeId] = $this.approverData.alternate_choices[parentId];
        }

        $.each($this.approverData.approvers, function(k,v){
            if(v instanceof Array) {
                $.each($this.approverData.approvers[k], function(k2,v2){
                   if(v2 == parentId) {
                       $this.approverData.approvers[k][k2] = nodeId;
                   }
                });
            } else {
                if(v == parentId) {
                    $this.approverData.approvers[k] = nodeId;
                }
            }
        });

        $this._chainUpdate(e, $this.approverData);

        val = val.split('_');
        val = val[val.length-1];

        //have to find the select again and mark the correct value as selected
        $this.chainElement
            .find('[data-node-id="'+nodeId+'"]')
            .find('select')
            .select2('val', 'choice_'+nodeId+'_'+val);
    }
  },

  _catchModalAddElementManual: function(e) {
    var $this = e.data.context,
        $el = $(this),
        val = $el.data('record');

    $this.$element.find('#people_search_key').val(val.name);
    $this.$element.find('.users.source-list').empty();
    $this.$element.find('.approval-chain-results').hide();
    $this.$element.find('.approval-add-manual button[type="submit"]').removeClass('disabled');

    $this.allowLoadResultList = false;
    $this.manualApproverData = val;
  },

  _catchManualFormSubmit: function(e) {
    e.preventDefault ? e.preventDefault() : (e.returnValue = false);
    e.stopPropagation();
    let $this = e.data.context,
        $el = $(this),
        element = $this.$element,
        input = element.find('input[name="' + element.data('update-name') + '"]');

      if (!bq.global.parsley.validationEnabled($el)) {
          bq.global.parsley.setupSingle($el);
      }

      bq.global.parsley.validate($el);
      if (!bq.global.parsley.isValid($el)) return;

      $this._modalClose(e);

      let reasonValue = $el.find('input[name="reason"]').val();
      if (typeof reasonValue !== 'string' || reasonValue.trim() === '') {
          reasonValue = bq.messages.approvers.approvalReasonDefault;
      }
      const approverData = $this.manualApproverData;

      approverData.reason = reasonValue;

      let nodeId;
      if ($this.currentTarget) {
          nodeId = $this._nodeAdd(approverData, $this.currentTarget.parent());
          $this.manualNodeIds.push(nodeId);
          $this._updateManualNodeAction();
      } else {
          nodeId = $this._watcherCreate(approverData)
      }

      $this._buildJsonSave();
      const json = input.val() || "{}";
      const reasons = JSON.parse(json).reasons || {};
      reasons[nodeId] = reasonValue;
      $this.updatedApproverData.reasons = reasons;

      input.val(JSON.stringify($this.updatedApproverData));
      $this._updateSubmitState();
  },

  _updateSubmitState: function() {
      if (this.submitBlocked) {
          this.$parentForm.trigger('bq:submit-vote', { plugin: 'rules', allow: false, note: this.submitBlockedNote, priority: 10 });
          return;
      }

      const data = this.initialApprovers;
      const approversChanged = JSON.stringify(this.updatedApproverData.approvers) !== JSON.stringify(data.approvers);
      const watchersChanged = JSON.stringify(this.updatedApproverData.watchers) !== JSON.stringify(data.watchers);
      this.$parentForm.trigger('bq:submit-vote', { plugin: 'approvers', allow: approversChanged || watchersChanged });
  },

  _catchManualCancel: function(e) {
    e.preventDefault();

    var $this = e.data.context;
    $this._modalClose(e);
  },

  _defineDefaultApprovers: function() {
    const input = this.$element.find('input[name="' + this.$element.data('update-name') + '"]');

    this._buildJsonSave();

    if (input) {
      const currentJson = JSON.stringify(this.updatedApproverData);
      input.val(currentJson);
    }
  },

  // THROW EVENT METHODS *******************************************

  throwEventUpdated: function() {
    bq.debug.log("Approvers: event thrown [bq.approvers.updated]");
    this.$element.trigger('bq.approvers.updated', this);
  }
};

// APPROVER CHAIN PLUGIN DEFINITION
// =======================

var approversold = $.fn.approvers;

$.fn.approvers = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.approvers');
    var options = $.extend({}, bq.approvers.DEFAULTS, $this.data(), typeof(option) === 'object' && option);
    if (!data) { $this.data('bq.approvers', (data = new bq.approvers(this, options))); }
    data.init();
  });
};

$.fn.approvers.Constructor = bq.approvers;

// APPROVER CHAIN NO CONFLICT
// =================

$.fn.approvers.noConflict = function () {
  $.fn.approvers = approversold;
  return this;
};

// APPROVER CHAIN DATA-API
// ==============
bq.approversInit = function() {
    $('[data-bq="approvers"]').each(function (index) {
      var el = $(this);
      if(el.data('bq.approvers')) { return; }
      el.attr('id', 'approver_chain_'+index);
      el.approvers(el.data());
    });
};

bq.init.push(bq.approversInit);